import type { AdvisorConnectResponse, ProfileResponse } from '@/api';

// Lightweight fixture used by AuthProvider — kept separate from demoData.ts
// so the heavy chart/fixture bundle is not pulled into the main chunk.
const demoUser: AdvisorConnectResponse & ProfileResponse = {
  success: true,
  id: 'demo-user-001',
  nom: 'Dupont',
  prenom: 'Marie',
  email: 'demo@meilleurtaux.com',
  telephone: '0600000000',
  adresse: '12 rue de la Paix',
  codePostal: '75002',
  ville: 'Paris',
  type: 'Client',
  advisorView: false,
  userId: 'demo-user-001',
  token: 'demo-token',
  dateTokenCreation: new Date().toISOString().split('T')[0],
};

export { demoUser };
